<div class="content-container mb-3">
  <div class="content">
    <div class="fw-bold mb-3">
      <label>
        <mwp-text-translate text="Report Detail" jsonKey="reportDetail" />
      </label>
    </div>
    <form [formGroup]="detailForm">
      <label class="label-alt">
        <mwp-text-translate text="File Name" jsonKey="fileName" />
      </label>
      <div class="mb-5 w-50">
        <mwp-input [form]="detailForm" [hideLabel]="true" nameForControl="fileName" />
      </div>
      <div class="mb-3">
        <label class="mb-3 fw-bold">{{caption}}</label>
        <div>
          <mat-checkbox formControlName="saveAsTemplate" (change)="selectionChange($event)" class="m-0">
            <mwp-text-translate text="Save selected parameters as a template?" jsonKey="reportBuilderDetailNote" />
          </mat-checkbox>
        </div>
        @if (displayTemplate) {
        <div class="mt-3">
          <div class="mb-3">
            <mwp-input [form]="detailForm" labelName="Template Name" nameForControl="templateName" />
          </div>
          <div>
            <mwp-textarea [form]="detailForm" labelName="Template Description" nameForControl="templateDescription" [autoTranslate]="true" />
          </div>
        </div>
        }
      </div>
      <div class="mb-3">
        <label class="fw-bold mb-3">
          <mwp-text-translate text="File Type Generated" jsonKey="fileTypeGenerated" />
        </label>
        <mwp-radio-button [form]="detailForm" nameForControl="fileType" [data]="fileTypes" keyText="description" keyValue="exportType" [displayInline]="false" />
      </div>
      <div class="mb-3">
        <label class="fw-bold mb-3">
          <mwp-text-translate text="Notification" jsonKey="notification" />
        </label>
        <div>
          <mat-checkbox formControlName="sendEmailOnFinish">
            <mwp-text-translate text="Send email when the report is ready for download." jsonKey="reportBuilderDetailSendEmailOnFinish" />
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
  <div class="footer d-inline-flex justify-content-end w-100">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    @if (detailForm) {
    <button class="mwp-button ms-3" [disabled]="!detailForm.valid" (click)="save()">
      <mwp-text-translate text="Continue" jsonKey="continue" />
    </button>
    }
  </div>
</div>